module.exports = __webpack_public_path__ + "static/media/5S.917cc6b0.svg";